import { Settings } from 'lucide-react';
import '../styles/global.css';

export function MaintenancePage() {
  return (
    <div className="app" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Settings size={64} style={{ animation: 'spin 4s linear infinite', color: 'var(--accent)', marginBottom: '24px' }} />
        <h1 style={{ fontSize: '2.5rem', marginBottom: '16px' }}>System Maintenance</h1>
        <p style={{ color: 'var(--text-3)', marginBottom: '8px' }}>PCCheckr is currently undergoing scheduled maintenance to improve our diagnostic capabilities.</p>
        <p style={{ color: 'var(--text-3)' }}>Please check back later.</p>
        
        <style>{`
          @keyframes spin { 100% { transform: rotate(360deg); } }
        `}</style>
      </div>
    </div>
  );
}
